import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDownMicro, ChevronUpMicro } from "../assets/SvgIcons";

const faqNav = [
  [
    {
      navTitle: "Overview",
      section: "/faqs#overview",
    },
    {
      navTitle: "FAQ / Help",
      section: "/faqs#help",
    },
    {
      navTitle: "Legal Details",
      section: "/faqs#legal-details",
    },
    {
      navTitle: "Marketplace Tax Collection",
      section: "/faqs#marketplace-tax-collection",
    },
    {
      navTitle: "Contact",
      section: "/faqs#contact",
    },
  ],
  [
    {
      navTitle: "Advice for private sellers",
      section: "/faqs#advice-for-private-sellers",
    },
    {
      navTitle: "Watch Terms Glossary",
      section: "/faqs#watch-terms-glossary",
    },
    {
      navTitle: "Condition Grades",
      section: "/faqs#condition-grades",
    },
    {
      navTitle: "Security Notes",
      section: "/faqs#security-notes",
    },
    {
      navTitle: "Why Register?",
      section: "/faqs#why-register",
    },
  ],
  [
    {
      navTitle: "Trade Shows",
      section: "/faqs#trade-shows",
    },
    {
      navTitle: "Link to Us",
      section: "/faqs#link-to-us",
    },
  ],
];
const allFaqs = [
  {
    title: "General Information",
    faqs: [
      {
        id: 1,
        question: "What is WristLink?",
        answer:
          "WristLink is an online platform for buying, selling, and trading second-hand luxury watches. We connect dealers and customers to offer a secure, trusted marketplace.",
      },
      {
        id: 2,
        question: "Is WristLink free to use?",
        answer:
          "Yes, signing up and browsing watches on WristLink is completely free. Sellers may incur a fee when listing their watches for sale.",
      },
      {
        id: 3,
        question: "How do I create an account on WristLink?",
        answer:
          "To create an account, click 'Sign Up' at the top of the page, enter your email, set a password, and confirm your email address.",
      },
      {
        id: 4,
        question: "How does WristLink ensure watch authenticity?",
        answer:
          "WristLink partners with certified watch experts who authenticate each watch listed on our platform. We also encourage buyers to review detailed information and images before purchasing.",
      },
    ],
  },
  {
    title: "Buying Watches",
    faqs: [
      {
        id: 5,
        question: "How do I buy a watch on WristLink?",
        answer:
          "Browse the listings, select a watch, and click 'Buy Now' to proceed with payment. You can choose from multiple secure payment options.",
      },
      {
        id: 6,
        question: "Can I negotiate the price of a watch?",
        answer:
          "Some sellers may be open to price negotiations. If the seller accepts offers, you will see an option to send an offer on the watch's page.",
      },
      {
        id: 7,
        question: "Is shipping included in the price?",
        answer:
          "Shipping fees may vary depending on the seller and your location. Shipping details will be provided on the watch's listing page.",
      },
      {
        id: 8,
        question: "Can I return a watch I purchased?",
        answer:
          "We offer a return policy for certain purchases. Please refer to the specific return policy of the seller for more details.",
      },
    ],
  },
  {
    title: "Selling Watches",
    faqs: [
      {
        id: 9,
        question: "How do I sell a watch on WristLink?",
        answer:
          "To sell a watch, create an account, click 'Sell a Watch', provide detailed information about the watch, upload clear photos, and set your price. Once approved, the watch will be listed for sale.",
      },
      {
        id: 10,
        question: "Are there any fees for selling a watch?",
        answer:
          "Yes, there is a small fee for listing your watch. The fee is deducted from the sale price once your watch sells. You will be notified of the exact fee before listing.",
      },
      {
        id: 11,
        question: "Can I edit my listing after it’s been posted?",
        answer:
          "Yes, you can edit your watch listing at any time, including changing the price, description, and photos.",
      },
    ],
  },
  {
    title: "Shipping & Delivery",
    faqs: [
      {
        id: 1,
        question: "What are the shipping options available?",
        answer:
          "We offer various shipping options including standard, expedited, and express shipping. The delivery time and cost depend on your location and the shipping method chosen at checkout.",
      },
    ],
    subSections: [
      {
        title: "Domestic Shipping",
        faqs: [
          {
            id: 1,
            question: "What are the shipping options?",
            answer:
              "We offer standard, expedited, and express shipping options. Shipping time depends on your location.",
          },
          {
            id: 2,
            question: "How do I track my order?",
            answer:
              "Once your order is shipped, you will receive a tracking number via email.",
          },
          {
            id: 3,
            question:
              "Can I change my shipping address after placing an order?",
            answer:
              "You can modify your shipping address within 24 hours of placing the order. After that, the order is processed and cannot be changed.",
          },
        ],
      },
      {
        title: "International Shipping",
        faqs: [
          {
            id: 4,
            question: "Do you ship internationally?",
            answer:
              "Yes, we ship worldwide. Shipping costs and delivery times vary by country.",
          },
          {
            id: 5,
            question:
              "Are there any customs fees or duties for international shipments?",
            answer:
              "Customs fees and duties may apply depending on your country's regulations. These charges are the responsibility of the buyer.",
          },
          {
            id: 6,
            question: "How long does international shipping take?",
            answer:
              "International shipping typically takes 7-14 business days, depending on the destination country and shipping method chosen.",
          },
        ],
      },
      {
        title: "Shipping Policies",
        faqs: [
          {
            id: 7,
            question: "Can I get expedited shipping?",
            answer:
              "Yes, we offer expedited shipping options at an additional cost. You can select this option during checkout.",
          },
          {
            id: 8,
            question: "What should I do if my order is delayed?",
            answer:
              "If your order is delayed, please contact our support team. We will track the shipment and provide an update.",
          },
          {
            id: 9,
            question: "Do you ship to P.O. Boxes?",
            answer:
              "We do not ship to P.O. Boxes. Please provide a valid residential or commercial address during checkout.",
          },
        ],
      },
    ],
  },
  {
    title: "Account & Privacy",
    faqs: [
      {
        id: 12,
        question: "How do I reset my password?",
        answer:
          "Click on 'Forgot Password' on the login page and follow the instructions to reset your password.",
      },
      {
        id: 13,
        question: "How do I update my profile information?",
        answer:
          "Log in to your account, go to 'Account Settings', and you can update your personal information, contact details, and password.",
      },
      {
        id: 14,
        question: "Is my information secure on WristLink?",
        answer:
          "Yes, we use industry-standard encryption and security measures to protect your personal and payment information. Your privacy is a top priority.",
      },
    ],
  },
  {
    title: "Marketplace Policies",
    faqs: [
      {
        id: 15,
        question: "What happens if I receive a damaged watch?",
        answer:
          "If you receive a damaged watch, please contact the seller immediately. We also have a dispute resolution process to help resolve any issues.",
      },
      {
        id: 16,
        question: "How do I report a fraudulent listing?",
        answer:
          "If you believe a listing is fraudulent, please contact our support team with the details, and we will investigate the matter promptly.",
      },
      {
        id: 17,
        question: "Can I buy watches internationally?",
        answer:
          "Yes, WristLink supports international purchases. Shipping fees and delivery times may vary based on your location.",
      },
    ],
  },
];

const FrequentlyAskedQuestions = () => {
  return (
    <>
      <PageLayout>
        <FaqAndNestedFaqSection allFaqs={allFaqs} />
        {/* Link to More FAQs */}
        <div className=" m-4 mt-8">
          <Link
            to="/info/faqs.htm"
            className=" border border-black lg:text-md md:text-md sm:text-sm px-4 py-2 rounded text-black hover:bg-gray-300"
          >
            More questions and answers
          </Link>
        </div>
      </PageLayout>
    </>
  );
};

export default FrequentlyAskedQuestions;

const PageLayout = ({ children }) => {
  return (
    <div className="mx-auto max-w-[1200px] lg:px-2 md:px-4 sm:px-4 py-4 flex gap-2 items-start">
      <div className="lg:w-3/12 md:w-3/12 sm:w-0 lg:block md:block sm:hidden">
        <FaqNavbar />
      </div>
      <div className="lg:w-9/12 md:w-9/12 sm:w-full">{children}</div>
    </div>
  );
};

const FaqNavbar = () => {
  return (
    <nav className="bg-white  w-full p-4 space-y-1">
      {faqNav?.map((navitem, index) => {
        return (
          <ul key={index} className=" text-[15px] border-b py-2">
            {navitem?.map((item, index2) => {
              return (
                <FaqNavItem
                  key={index2}
                  navTitle={item.navTitle}
                  navIcon={item.navIcon}
                  navRoute={item.navRoute}
                  badge={item.badge}
                />
              );
            })}
          </ul>
        );
      })}
    </nav>
  );
};

const FaqNavItem = ({ navTitle, navRoute, badge }) => {
  return (
    <li>
      <Link
        to={navRoute}
        className="flex items-center pb-2.5 space-x-2 text-black hover:text-primary"
      >
        <p className="text-[14px]">{navTitle}</p>
        {badge !== undefined && badge !== 0 && badge !== "" && (
          <span className="pill bg-red-500 text-white text-[12px] font-semibold rounded-full text-center h-[16px] w-[16px] ml-auto">
            {badge}
          </span>
        )}
      </Link>
    </li>
  );
};

const FaqAndNestedFaqSection = ({ allFaqs, titleClassName }) => {
  return (
    <div className="px-4">
      {allFaqs?.map((faqItem, index) => {
        return (
          <div key={index} className="mt-4">
            {/* TITLE AND STUFFS */}
            <h2
              className={` mb-4 ${
                titleClassName
                  ? titleClassName
                  : "lg:text-3xl md:text-2xl sm:text-xl"
              }`}
            >
              {faqItem?.title}
            </h2>

            {faqItem?.faqs && <FaqItems faqs={faqItem?.faqs} />}

            {faqItem?.subSections && (
              <div className=" border-l border-dashed">
                <FaqAndNestedFaqSection
                  titleClassName={"lg:text-xl md:text-xl sm:text-lg "}
                  allFaqs={faqItem?.subSections}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const FaqItems = ({ faqs }) => {
  const [expanded, setExpanded] = useState(null);

  const toggleAccordion = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div className="">
      {/* FAQ Accordion Section */}
      <div className="contact-faq-section ">
        <div className="accordion">
          {faqs?.map((faq) => (
            <div key={faq?.id} className="accordion-item border-b">
              <button
                onClick={() => toggleAccordion(faq?.id)}
                className="accordion-head w-full text-left py-4 lg:text-md md:text-md sm:text-sm font-medium flex justify-between items-center"
              >
                <p>{faq?.question}</p>
                {expanded === faq?.id ? ChevronUpMicro : ChevronDownMicro}
              </button>

              <div
                className={` transition-all text-[14px] duration-300 ease-in-out overflow-hidden ${
                  expanded === faq?.id ? "max-h-[800px] " : "max-h-0 "
                }`}
              >
                <div
                  className={`  transition-opacity duration-300 ${
                    expanded === faq?.id ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <p className="accordion-body pb-4 text-gray-700 lg:text-sm md:text-sm sm:text-xs">
                    {faq?.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
